/**
 * 客户管理
 */

export default [
  {
    label: '企业管理',
    icon: 'icon-xinzengsp',
    permission:'cus_manage',
    id:'2',
    children: [
      {
        label: '企业管理',
        icon: 'icon-yonghu',
        path: '/cus/manage',
        permission: 'cus_manage',
        id:'2-1',
      },
      {
        label: '企业信息',
        icon: 'icon-yonghu',
        path: '/cus/info',
        permission: 'cus_info_edit',
        id:'2-2',
      },
      {
        label: '企业订单',
        icon: 'icon-yonghu',
        path: '/cus/order',
        permission: 'cus_order',
        id:'2-3',
      },
      {
        label: '企业员工',
        icon: 'icon-yonghu',
        path: '/cus/emp',
        permission: 'cus_emp',
        id:'2-4',
      }
    ],
  },
];

